





































































































































































































import {Component, Vue} from 'vue-property-decorator';
import {appName} from '@/env';
import {readAppConfigs, readLoginError} from '@/store/main/getters';
import {dispatchTwoFactorLogIn} from '@/store/main/actions';
// @ts-ignore
import backgroundImg from '@/assets/images/bg-2.jpg';
// @ts-ignore
import backgroundImgX2 from '@/assets/images/bg-2.jpg';

import {FmvAvatar} from 'fmv-avatar';
import {FmvInputGroupMerge} from 'fmv-input-group-merge';

@Component({
  components: {
    FmvAvatar,
    FmvInputGroupMerge,
  },
})
export default class Login extends Vue {
  public authStep: string = 'credentials';
  public username: string = '';
  public password: string = '';
  public gaCode: string = '';
  public secretCode: string = '';
  public brand: string = 'unifordi';
  public logoPath: string = '@/assets/images/logo.svg';
  public linkComponent: string = 'b-link';
  public appName = appName;
  public backgroundImage = backgroundImg;
  public backgroundImageX2 = backgroundImgX2;
  public registerLink = '/register';
  public googleError: boolean = false;
  public secretCodeError: boolean = false;
  public secretCodeTimer: number = 300;
  public timeinterval: any = null;

  public get loginError() {
    return readLoginError(this.$store);
  }

  get appConfigs() {
    return readAppConfigs(this.$store);
  }

  public async mounted() {
    this.registerLink = '/register'; // await dispatchGetAdminRegisterLink(this.$store);
  }

  public async submitAuth() {
    this.username = this.username.replace('+', '').replaceAll(' ', '').replace('(', '').replace(')', '').replaceAll('-', '')
    const response = await dispatchTwoFactorLogIn(
      this.$store, {username: this.username, password: this.password, auth_step: 'credentials'},
    );
    if (response && response.next_step) {
      this.authStep = response.next_step;
      if (response.next_step === 'secret_key') {
        this.initializeClock();
      }
    }
  }

  public async submitGoogle() {
    if (!this.gaCode) {
      this.$t('Please, enter code');
      return;
    }
    const response = await dispatchTwoFactorLogIn(
      this.$store, {username: this.username, password: this.password, auth_step: 'google', code: this.gaCode},
    );
    if (response && response.next_step) {
      this.authStep = response.next_step;
      if (response.next_step === 'secret_key') {
        this.initializeClock();
      }
    }
    this.googleError = response && response.valid && response.valid === 'False' ? true : false;
  }

  public async submitSecret() {
    if (this.secretCodeTimer <= 0) {
      this.$t('Login time has expired. Please try again');
      return;
    }
    if (!this.secretCode) {
      this.$t('Please, enter code');
      return;
    }
    const response = await dispatchTwoFactorLogIn(
      this.$store, {username: this.username, password: this.password, auth_step: 'secret_key', code: this.secretCode},
    );
    if (response && response.next_step) {
      this.authStep = response.next_step;
    }
    this.secretCodeError = response && response.valid && response.valid === 'False' ? true : false;
  }

  public initializeClock() {
    if (this.timeinterval) {
      clearInterval(this.timeinterval);
      this.timeinterval = null;
    }
    this.timeinterval = setInterval(() => {
      const seconds = this.secretCodeTimer > 0 ? Math.floor( (this.secretCodeTimer) % 60 ) : '00';
      const minutes = this.secretCodeTimer > 0 ? Math.floor( (this.secretCodeTimer / 60) % 60 ) : '00';
      // @ts-ignore
      this.$refs['countdown'].innerHTML = `${minutes}:${seconds}`;
      if (this.secretCodeTimer <= 0) {
        clearInterval(this.timeinterval);
        this.timeinterval = null;
      } else {
        this.secretCodeTimer -= 1;
      }
    }, 1000);
  }

  public beforeDestroy() {
    if (this.timeinterval) {
      clearInterval(this.timeinterval);
      this.timeinterval = null;
    }
  }

}
